type Props = {
  status: string
}

const UserStatusCell = ({status}: Props) => {
  const statusText =
    status === 'A' ? 'Active' : status === 'S' ? 'Blocked' : status === 'P' ? 'Pending' : 'N/A'
  const statusColor =
    status === 'A' ? 'success' : status === 'S' ? 'danger' : status === 'P' ? 'primary' : 'light'

  return <span className={`badge fs-6 badge-light-${statusColor}`}>{statusText}</span>
}

export default UserStatusCell
